import { combineReducers } from 'redux';
import { entitiesReducer, queriesReducer } from 'redux-query';
import { OverlaysState } from 'data/overlays/interfaces';
import overlaysReducer from 'data/overlays/overlaysReducer';
import selectedVehicleReducer from 'data/selectedVehicle/selectedVehicleReducer';

export interface IStoreState {
    overlaysReducer: OverlaysState;
}

const combineRootReducer = combineReducers({
    entities: entitiesReducer,
    queries: queriesReducer,
    overlaysReducer,
    selectedVehicleReducer,
});

export default combineRootReducer;
